module.exports = __webpack_public_path__ + "media/student_v2/assets/images/eye-affbf6722c5aac8f1571da0d4fa57b5b.svg";